import { createStore } from 'vuex';

import { store as lang, LangStore, State as LangState } from '@/store/modules/Lang/';
import { store as countries, CountryStore, State as CountryState } from '@/store/modules/Countries/';
import { store as insurances, InsuranceStore, State as InsuranceState } from '@/store/modules/Insurances/';
import { store as quotes, QuoteStore, State as QuoteState } from '@/store/modules/Quotes/';
import { store as relationships, RelationshipStore, State as RelationshipState } from '@/store/modules/Relationships/';
import { store as personals, PersonalStore, State as PersonalState } from '@/store/modules/Personals/';
import { store as review, ReviewStore, State as ReviewState } from '@/store/modules/Review/';
import { store as checkout, CheckoutStore, State as CheckoutState } from '@/store/modules/Checkouts';
import { store as coupon, CouponStore, State as CouponState } from '@/store/modules/Coupons';

export type RootState = {
  countries: CountryState;
  lang: LangState;
  insurances: InsuranceState;
  relationships: RelationshipState;
  personals: PersonalState;
  review: ReviewState;
  quotes:QuoteState;
  checkout: CheckoutState;
  coupon: CouponState;
};

export type Store = LangStore<Pick<RootState, 'lang'>>
& CountryStore<Pick<RootState, 'countries'>>
& InsuranceStore<Pick<RootState, 'insurances'>>
& QuoteStore<Pick<RootState, 'quotes'>>
& RelationshipStore<Pick<RootState, 'relationships'>>
& ReviewStore<Pick<RootState, 'review'>>
& PersonalStore<Pick<RootState, 'personals'>>
& CheckoutStore<Pick<RootState, 'checkout'>>
& CouponStore<Pick<RootState, 'coupon'>>;

export const store = createStore({
  modules: {
    countries,
    checkout,
    review,
    insurances,
    quotes,
    lang,
    personals,
    relationships,
    coupon,
  }
});

export function useStore(): Store {
  return store as Store;
}
